import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import { Login } from '@signature-it/ngx-generic/models';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import {catchError, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

  protected loginUrl = `${this.restUrlsConf.appURL}/public/auth/login`;
  protected clubLoginUrl = `${this.restUrlsConf.appURL}/public/auth/club-login`;
  protected clubLogOutUrl = `${this.restUrlsConf.appURL}/public/auth/club-logout`;
  protected loginBySmsUrl = `${this.restUrlsConf.appURL}/public/auth/send_sms_login_code`;
  protected verifySmsLoginCodeUrl = `${this.restUrlsConf.appURL}/public/auth/verify_sms_login_code`;
  protected logoutUrl = `${this.restUrlsConf.appURL}/public/auth/logout`;

  constructor(protected http: HttpClient,
              protected restUrlsConf: RestUrlsConfig) { }

  login(login: Login): Observable<Login> {
    return this.http.post<Login>(this.loginUrl, JSON.stringify(login))
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  sendSmsLoginCode(login: Login): Observable<Login> {
    return this.http.post<Login>(this.loginBySmsUrl, JSON.stringify(login))
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  verifySmsLoginCode(login: Login): Observable<Login> {
    return this.http.post<Login>(this.verifySmsLoginCodeUrl, JSON.stringify(login))
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  logout(): Observable<any> {
    return this.http.post(this.logoutUrl,'')
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  clubLogin(login): Observable<any> {
    return this.http.post(this.clubLoginUrl, JSON.stringify(login))
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  clubLogOut(): Observable<any> {
    return this.http.post(this.clubLogOutUrl, '')
        .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
  }

  isLoginRouteInSignatureEnv(url) {
    return url.includes(this.loginUrl) && /\.(signature-it|signatureit)\.(app|com)$/.test(location.hostname);
  }
}
